<template>
  <div class="rb-ob-form rb-match-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.matchNoslotTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ $t('intake.matchNoslotBody') }}</p>
    </div>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="goAvailability">
        {{ $t('intake.matchNoslotOtherTimesAction') }}
      </button>
      <button class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="goAvailability">
        {{ $t('intake.matchNoslotEditPrefsAction') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite"></p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchNoslotStep',
  methods: {
    goAvailability() {
      this.$router.push({
        name: 'intakeScreening',
        params: {lang: this.$route.params.lang || 'fa'},
        query: {revise_preferences: '1'},
      })
    },
  },
}
</script>
